import { useEffect } from "react";

import { UseFormReturnType } from "@mantine/form";

import { useRegisterEncounterChildSave } from "@/encounters/contexts/EncounterChildSaveContext";
import { NewbornProceduresForm } from "@/newborn-procedures/zod-schemas/newborn-procedures";
import { NewbornSystemsForm } from "@/newborn-systems/zod-schemas/newborn-systems";

import { PostpartumOutputFormType } from "../../encounters/zod-schemas/postpartum-encounter";
import { PhysicalExamForm } from "../../physical-exams/zod-schemas/physical-exams";

type FormType =
  | PhysicalExamForm
  | NewbornSystemsForm
  | NewbornProceduresForm
  | PostpartumOutputFormType;

// TODO: Remove this hook and implement a proper form submission method
export function useTemporarySubmit<T extends FormType>(
  form: UseFormReturnType<T>,
  submitTrigger: number,
  handleSubmit: (values: T) => Promise<void>,
) {
  useRegisterEncounterChildSave(async () => handleSubmit(form.values));

  useEffect(
    () => {
      // TODO: Refactor how submit is handled when we refactor Encounters
      // This should not need an external trigger to submit.
      if (submitTrigger > 0) {
        handleSubmit(form.values);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [submitTrigger],
  );
}
